import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Typography from '@lib/components/Typography/Typography';
import SsoProviderButton from 'components/SsoProviderButton/SsoProviderButton';
import { SsoIntegrationPreviewData } from 'utils/sso';
import styles from './LoginForm.module.scss';

interface LoginSsoButtonsProps {
  ssoIntegrations: SsoIntegrationPreviewData[];
  onSsoLogin: (code: string) => void;
  passwordAllowed: boolean;
}

function LoginSsoButtons({
  ssoIntegrations,
  onSsoLogin,
  passwordAllowed,
}: LoginSsoButtonsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.ssoSection} data-test-id="login__sso-buttons">
      <div
        className={cn(styles.ssoButtons, {
          [styles.ssoButtonsSingle]: ssoIntegrations.length === 1,
          [styles.ssoButtonsDouble]: ssoIntegrations.length === 2,
        })}
      >
        {ssoIntegrations.map((integration) => (
          <SsoProviderButton
            key={integration.code}
            integration={integration}
            onClick={onSsoLogin}
          />
        ))}
      </div>
      {passwordAllowed && (
        <div className={styles.divider}>
          <span className={styles.dividerLine} />
          <Typography variant="caption" className={styles.dividerText}>
            {t('or-continue-with-password')}
          </Typography>
          <span className={styles.dividerLine} />
        </div>
      )}
    </div>
  );
}

export default LoginSsoButtons;
